"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _confirm = _interopRequireDefault(require("../../style/confirm"));

var _react = _interopRequireDefault(require("react"));

var _l10n = _interopRequireDefault(require("../../../../common/l10n"));

var _Button = _interopRequireDefault(require("../../../Button"));

var _createStyled = _interopRequireDefault(require("../../../../utils/createStyled"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Div = _createStyled["default"].div(_templateObject()),
    Form = _createStyled["default"].form(_templateObject2());

function template() {
  var titleContent = null;
  var styles = this.compileStyled(_confirm["default"]),
      _this$props = this.props,
      submitLabel = _this$props.submitLabel,
      needTitle = _this$props.needTitle,
      title = _this$props.title,
      cancelLabel = _this$props.cancelLabel,
      _this$props$className = _this$props.className,
      className = _this$props$className === void 0 ? '' : _this$props$className,
      children = _this$props.children,
      _this$props$style = _this$props.style,
      style = _this$props$style === void 0 ? {} : _this$props$style;

  if (needTitle) {
    titleContent = _react["default"].createElement(Div, {
      styles: styles.title
    }, _l10n["default"].translate(title));
  }

  return _react["default"].createElement(Form, {
    action: "/",
    method: "post",
    styles: styles.root,
    onSubmit: this.submit,
    className: className
  }, titleContent, _react["default"].createElement(Div, {
    styles: styles.content
  }, children), _react["default"].createElement(Div, {
    styles: styles.controls
  }, _react["default"].createElement(Div, {
    styles: styles.cancelButton
  }, _react["default"].createElement(_Button["default"], {
    style: _objectSpread({
      width: '100%'
    }, style.button),
    onClick: this.cancel,
    "data-qa-node": "popup-confirm-button",
    "data-qa-value": "cancel"
  }, _l10n["default"].translate(cancelLabel))), _react["default"].createElement(Div, {
    styles: styles.button
  }, _react["default"].createElement(_Button["default"], {
    primary: true,
    style: _objectSpread({
      width: '100%'
    }, style.button),
    type: "submit",
    "data-qa-node": "popup-confirm-button",
    "data-qa-value": "submit"
  }, _l10n["default"].translate(submitLabel)))));
}